import request from './request';

const bannerService = {
  getAll: (params) =>
    request.get('dashboard/admin/banners', { params }),
  getPaginate: (params) =>
    request.get('dashboard/admin/banners/paginate', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/banners/${id}`, { params }),
  create: (data) => request.post('dashboard/admin/banners', data, {}),
  update: (id, data) => request.put(`dashboard/admin/banners/${id}`, data, {}),
  delete: (data) =>
    request.delete('dashboard/admin/banners/delete', { data }),
  deleteBulk: ({ ids }) =>
    request.delete('dashboard/admin/banners/delete', { data: { ids } }),
  deleteById: (id) =>
    request.delete(`dashboard/admin/banners/${id}`),
  clone: (id) =>
    request.post(`dashboard/admin/banners/clone/${id}`),
  setActive: (id) => request.post(`dashboard/admin/banners/active/${id}`),
  dropAll: () => request.get('dashboard/admin/banners/drop/all'),
  restoreAll: () => request.get('dashboard/admin/banners/restore/all'),
};

export default bannerService;
